/**
 * @param {ProductFront} productFront
 * @param {Specification} specification
 * @returns {SpecificationConfiguration}
 */
export const buildSpecificationConfiguration = (productFront, specification) => {
	const configuration = defaultConfigurationFor(productFront.id, specification);
	const optionList = specification.productOptionGroups
		.flatMap(optionGroup => optionGroup.productOptions);

	for (const optionGroup of specification.productOptionGroups) {
		let optionToChoose = findBestChoiceOption(optionGroup.productOptions);

		if (!optionToChoose) {
			optionToChoose = findCheapestOption(optionGroup.productOptions);
		}

		if (optionToChoose.requiredProductOptionIds.length) {
			const requiredOption = findRequiredOption(optionList, optionToChoose);
			const requiredOptionGroup = findRequiredOptionGroup(specification.productOptionGroups, requiredOption);
			const indexOfOptionGroup = specification.productOptionGroups.indexOf(requiredOptionGroup);

			configuration.productOptionIds.splice(indexOfOptionGroup, 1, requiredOption.id);
		}

		configuration.productOptionIds.push(optionToChoose.id);
	}

	return configuration;
};

/**
 * @param {ProductOption[]} options
 * @returns {ProductOption}
 */
const findBestChoiceOption = (options) => {
	return options.find(o => o.isBestChoice);
};

/**
 * @param {ProductOption[]} options
 * @returns {ProductOption}
 */
const findCheapestOption = (options) => {
	return options
		.sort((a, b) => a.amountPrices[0].price - b.amountPrices[0].price)
		.first();
};

/**
 * @param {ProductOption[]} options
 * @param {ProductOption} optionToChoose
 * @returns {ProductOption}
 */
const findRequiredOption = (options, optionToChoose) => {
	return options.find(o => o.id === optionToChoose.requiredProductOptionIds.first());
};

/**
 * @param {ProductOptionGroup[]} optionGroups
 * @param {ProductOption} requiredOption
 * @returns {ProductOptionGroup}
 */
const findRequiredOptionGroup = (optionGroups, requiredOption) => {
	return optionGroups.find(og => og.productOptions.find(o => o.id === requiredOption.id));
};

/**
 * @param {number} productFrontId
 * @param {Specification} specification
 * @returns {SpecificationConfiguration}
 */
const defaultConfigurationFor = (productFrontId, specification) => ({
	id: 0,
	specificationId: specification.id,
	productFrontId: productFrontId,
	productOptionIds: [],
	productGroupIdsForcedByEditor: [],
	amount: specification.amount ? specification.amount : specification.minAmount,
	pages: specification.minPageCount,
	// The specification sizes include bleed, the configured size is without bleed
	widthInMm: specification.minWidthInMm - 2 * (specification.bleed || 0),
	heightInMm: specification.minHeightInMm - 2 * (specification.bleed || 0),
	previewUrl: "",
	hasOffsetPrintingAmount: false
});



// WEBPACK FOOTER //
// ./src/helpers/specification/buildSpecificationConfiguration.js